module.exports = __webpack_public_path__ + "8161e6f5b1dadc4ace622f207ce650bf.MP3";